import { render, staticRenderFns } from "./refund-spu-list-widget.vue?vue&type=template&id=ad2ebf4c&scoped=true"
import script from "./refund-spu-list-widget.vue?vue&type=script&lang=js"
export * from "./refund-spu-list-widget.vue?vue&type=script&lang=js"
import style0 from "./refund-spu-list-widget.vue?vue&type=style&index=0&id=ad2ebf4c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2ebf4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad2ebf4c')) {
      api.createRecord('ad2ebf4c', component.options)
    } else {
      api.reload('ad2ebf4c', component.options)
    }
    module.hot.accept("./refund-spu-list-widget.vue?vue&type=template&id=ad2ebf4c&scoped=true", function () {
      api.rerender('ad2ebf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/refund-spu-list-widget.vue"
export default component.exports